import Base from './Base';

class Generic extends Base {

    constructor (token) {
        super(token);
    }

    setEndpoint(endpoint){
        this.endpoint = endpoint;
        return this
    }

    
}

export default Generic;